import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';


import CustomSelect from '../../shared/CustomSelect';

class UserEntitlementAccountList extends Component {
  static propTypes = {
    accounts: PropTypes.instanceOf(Array),
    handleAccountChange: PropTypes.func,
  }
  static defaultProps = {
    accounts: [],
  };
  state = {
    accountOptions: [],
  }

  UNSAFE_componentWillMount() {
    const { accounts } = this.props;
    const accountOptions = [];
    _.map(accounts, account => {
      const isTPP = account.accountType === 'TPP' ? true : false;
      accountOptions.push({
        ...account,
        label: isTPP
          ? account.accountName + ' ' + '(Third Party)'
          : account.accountName,
        value: account.accountId,
      });
    });
    this.setState({ accountOptions });
  }

  handleAccountChange = account => {
    this.props.handleAccountChange(account.accountId,account.publicId);
  }

  render() {
    const { accountOptions } = this.state;
    return (
      <div className="user-search--form-group user-search--form-dropdown teams-account-dropdown">
        <label className="sr-only" htmlFor="searchAccounts">Search by Accounts</label>
        <CustomSelect
          options={accountOptions}
          onChange={this.handleAccountChange}
          placeholder="Accounts Associated with subscription"
          id="searchAccounts"
          name="searchAccounts"
          defaultSelectedItem="0"
        />
      </div>
    );
  }
}


export default UserEntitlementAccountList;
